import { StyleSheet } from 'react-native';
import Theme from 'Theme';

const baseStyles = {
    editContainer: {
        height: 50,
        backgroundColor: '#32393F',
        alignItems: 'flex-end'
    },
    editTouchArea: {
        height: 50,
        flexDirection: 'row-reverse',
        alignItems: 'center'
    },
    editText: {
        fontFamily: Theme.boldFont,
        fontSize: 19,
        marginRight: Theme.primaryMargin,
        marginLeft: 10,
        color: Theme.primaryTextColor
    },
    editIcon: {
        height: 25,
        width: 25
    },
    selectAllText: {
        fontFamily: Theme.boldFont,
        fontSize: 19,
        marginLeft: 10,
        color: Theme.primaryTextColor
    },
    selectAllCheckbox: {
        marginHorizontal: Theme.BU,
        borderColor: Theme.primaryTextColor
    }
};

export default StyleSheet.create(baseStyles);
